import {
    FETCH_AI_MAILER_QUESTIONS,
    CLEAN_AI_MAILER_QUESTIONS,
    DELETE_AI_MAILER_QUESTION,
    DELETE_AI_MAILER_QUESTIONS,
    EDIT_AI_MAILER_QUESTION,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const AI_MAILER_QUESTIONS_DEFAULT_STATE = {};

const AiMailerQuestionsReducer = (state = AI_MAILER_QUESTIONS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_MAILER_QUESTIONS:
            return payload;

        case EDIT_AI_MAILER_QUESTION:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, language: payload.language, input: payload.input, output: payload.output };
                }

                return item;
            }) };

        case CLEAN_AI_MAILER_QUESTIONS:
        case DELETE_AI_MAILER_QUESTION:
        case DELETE_AI_MAILER_QUESTIONS:
            return AI_MAILER_QUESTIONS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiMailerQuestionsReducer;
